import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ViewTypeName } from "@air/api/types/configurableView";
import { memo } from "react";
import { useSelector } from "react-redux";
import { PublicBoardActivityContainer } from "~/components/PublicBoardActivityContainer";
import { PublicBoardAssetModal } from "~/components/PublicBoardAsset/PublicBoardAssetModal";
import { PublicBoardGalleryView } from "~/components/v2/components/board/gallery/PublicBoardGalleryView";
import { PublicBoardTableView } from "~/components/v2/components/board/shared/table/PublicBoardTableView";
import { PublicKanbanView } from "~/components/v2/components/shared/kanban/PublicKanbanView";
import { PUBLIC_BOARD_CHILDREN_CONTAINER } from "~/constants/testIDs";
import { useRerenderOnMount } from "~/hooks/useRerenderOnMount";
import { useURLClipIdSelector } from "~/hooks/useURLClipIdSelector";
import { AnnotationProvider } from "~/providers/AnnotationProvider/AnnotationProvider";
import { useScrollElementContext } from "~/providers/ScrollElementProvider";
import { currentViewTypeNameSelector } from "~/store/configViews/selectors";
export const PublicBoardContent = /*#__PURE__*/ memo(()=>{
    const clipId = useURLClipIdSelector();
    const { isMounted } = useRerenderOnMount();
    const { scrollElementRef } = useScrollElementContext();
    const viewTypeName = useSelector(currentViewTypeNameSelector);
    return /*#__PURE__*/ _jsxs("div", {
        className: "grow",
        "data-testid": PUBLIC_BOARD_CHILDREN_CONTAINER,
        children: [
            viewTypeName === ViewTypeName.gallery && /*#__PURE__*/ _jsx(PublicBoardGalleryView, {
                className: "mt-0",
                containerHorizontalPadding: 16,
                boardItemHorizontalSpacing: 8,
                assetItemHorizontalSpacing: 8,
                fileItemHorizontalSpacing: 8,
                headerContainerHeight: 32,
                scrollElementRef: scrollElementRef
            }),
            viewTypeName === ViewTypeName.table && /*#__PURE__*/ _jsx(PublicBoardTableView, {
                scrollElementRef: scrollElementRef
            }),
            viewTypeName === ViewTypeName.kanban && /*#__PURE__*/ _jsx(PublicKanbanView, {}),
            !!clipId && isMounted && /*#__PURE__*/ _jsx(AnnotationProvider, {
                children: /*#__PURE__*/ _jsx(PublicBoardAssetModal, {})
            }),
            /*#__PURE__*/ _jsx(PublicBoardActivityContainer, {})
        ]
    });
});
PublicBoardContent.displayName = "PublicBoardContent";
